import { omit } from 'ramda';
import api from '../../../config/api';
import { useModel } from '../../use';
import { message } from '..';
import { network, generators, asserts } from '../../../utils';
import { inventoryCal } from '../../../utils/biz';
import { getFavorite, collect, custom, getStockList } from '../../../service/common';
import paginationCfg from '../../../config/pagination.cfg';

const { generatorObject, generatorArray } = generators;

const initialState = {
  largeClass: {}, //左边固定行业大类
  carousel: [], // 有部分轮播数据
  splitConfig: [],
  dataSource: [], // table数据源
  favorite: [], //收藏夹列表
  stockList: [],
  selectionSource: [], //下拉框数据源
  selectedInd: '', // 选中的行业id
  selectedValue: {}, // 选中的item(用来查询下边的下拉框和商品表)
  pagination: {
    ...paginationCfg(),
    pageSizeOptions: ['10', '20', '50'],
  },
};

const updateState = (state, payload) => ({ ...state, ...payload });

const effects = {
  /**
   * 行业专区表格数据查询
   */
  queryTable: async ({ payload: params, dispatch, state }) => {
    const { pageIndex, pageSize } = params;
    const invalidKey = Object.keys(params).filter((item) => !asserts.isExist(params[item]));
    const queryParams = omit(invalidKey, Object.assign({}, params));
    const response = await network({
      url: api.search.table,
      method: 'get',
      params: queryParams,
    });
    if (response.success) {
      const result = generatorObject(response.data);
      if (result.success) {
        const data = generatorObject(result.data);
        const dataSource = generatorArray(data.list).map((item) => ({
          ...item,
          pcs: item.cartItemQty
            ? inventoryCal(
                item.cartItemQty,
                item.moqnum,
                item.packspec,
                item.saleUom,
                item.saleUomDesc,
              )
            : 0,
        }));
        const { total = 0 } = data;
        dispatch('updateState')({
          dataSource,
          pagination: { ...state.pagination, total, current: pageIndex, pageIndex, pageSize },
        });
      } else {
        message.error(generatorObject(response.data).message);
      }
    }
  },

  // 2021.11.17 行业专区商品查询列表接口替换
  queryIndustryTable: async ({ payload: params, dispatch, state }) => {
    const { pageIndex, pageSize } = params;
    const invalidKey = Object.keys(params).filter((item) => !asserts.isExist(params[item]));
    const queryParams = omit(invalidKey, Object.assign({}, params));
    const response = await network({
      url: api.industries.list,
      method: 'get',
      params: queryParams,
    });
    if (response.success) {
      const data = generatorObject(response.data);
      const dataSource = generatorArray(data.rows).map((item) => ({
        ...item,
        pcs: item.cartItemQty
          ? inventoryCal(
              item.cartItemQty,
              item.moqnum,
              item.packspec,
              item.saleUom,
              item.saleUomDesc,
            )
          : 0,
      }));
      const { total = 0 } = data;
      dispatch('updateState')({
        dataSource,
        pagination: { ...state.pagination, total, current: pageIndex, pageIndex, pageSize },
      });
    }
  },

  // 特价区数据查询
  querySpecialTable: async ({ payload: params, dispatch, state }) => {
    const { pageIndex, pageSize } = params;
    const invalidKey = Object.keys(params).filter((item) => !asserts.isExist(params[item]));
    const queryParams = omit(invalidKey, Object.assign({}, params));
    const response = await network({
      url: api.sales.list,
      method: 'get',
      params: queryParams,
    });
    if (response.success) {
      const dataSource = generatorArray(response.data.rows).map((item) => ({
        ...item,
        pcs: item.cartItemQty
          ? inventoryCal(item.cartItemQty, item.moq, item.packspec, item.saleUom, item.saleUomDesc)
          : 0,
      }));
      const { total = 0 } = response.data;
      dispatch('updateState')({
        dataSource,
        pagination: { ...state.pagination, total, current: pageIndex, pageIndex, pageSize },
      });
    }
  },

  // 获取收藏夹列表
  queryFavorite: async ({ payload, dispatch }) => {
    const response = await getFavorite();
    if (response.success) {
      const favorite = generatorArray(response.data.data);
      dispatch('updateState')({ favorite });
    }
  },
  collect: async ({ payload, dispatch }) => {
    const { collectParams, isSpecialOffer, tableQueryParams, isNew } = payload;
    const response = await collect(collectParams);
    if (response.success) {
      if (response.data.success) {
        isSpecialOffer
          ? dispatch('querySpecialTable')(tableQueryParams)
          : dispatch('queryTable')(tableQueryParams);
        if (isNew) {
          dispatch('queryFavorite')(); //如果有新建的收藏夹，收藏之后刷新收藏夹列表
        }
      } else {
        message.error(response.data.message);
      }
    }
  },

  custom: async ({ payload, dispatch }) => {
    const { customParams, isSpecialOffer, tableQueryParams } = payload;
    const response = await custom(customParams);
    if (response.success) {
      if (response.data.success) {
        isSpecialOffer
          ? dispatch('querySpecialTable')(tableQueryParams)
          : dispatch('queryTable')(tableQueryParams);
      } else {
        message.error(response.data.message);
      }
    }
  },
  // 获取拆分标识列表
  queryStockList: async ({ payload, dispatch }) => {
    const response = await getStockList();
    if (response.success) {
      const stockList = generatorArray(response.data.data);
      dispatch('updateState')({ stockList });
    }
  },
};
const SelecyionTableModel = () =>
  useModel({
    state: initialState,
    reducers: { updateState },
    effects,
  });

export default SelecyionTableModel;
